import './ImagesMosaic.css'

interface IProps {
  index: number
  onClick: (index: number) => void
}

const MosaicRef = (props: IProps) => {
  return (
    <span className="mosaic-ref" onClick={() => props.onClick(props.index)}>
      (#{props.index})
    </span>
  )
}

export default MosaicRef
